import { render } from "./Knowledgeware.vue?vue&type=template&id=43f055cb&scoped=true"
import script from "./Knowledgeware.vue?vue&type=script&lang=js"
export * from "./Knowledgeware.vue?vue&type=script&lang=js"

import "./Knowledgeware.vue?vue&type=style&index=0&id=43f055cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f055cb"]])

export default __exports__